import { trpc } from "../../../modules/main/components/trpc.ts";
import type {
  AssistantDeleteFavoriteActeInput,
  AssistantUpsertFavoriteActeInput,
} from "cadendar-shared";

export const useAssistantFavoriteActes = () => {
  const utils = trpc.useUtils();

  const favoritesQuery = trpc.ccam.listAssistantFavoriteActes.useQuery(undefined, {
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
  });

  const upsertMutation = trpc.ccam.upsertAssistantFavoriteActe.useMutation({
    onSuccess: async () => {
      await utils.ccam.listAssistantFavoriteActes.invalidate();
    },
  });

  const deleteMutation = trpc.ccam.deleteAssistantFavoriteActe.useMutation({
    onSuccess: async () => {
      await utils.ccam.listAssistantFavoriteActes.invalidate();
    },
  });

  const upsertFavorite = async (input: AssistantUpsertFavoriteActeInput) => {
    return upsertMutation.mutateAsync(input);
  };

  const deleteFavorite = async (input: AssistantDeleteFavoriteActeInput) => {
    return deleteMutation.mutateAsync(input);
  };

  return {
    favorites: favoritesQuery.data ?? [],
    isLoading: favoritesQuery.isLoading,
    error: favoritesQuery.error,
    upsertFavorite,
    deleteFavorite,
    isSaving: upsertMutation.isPending,
    isDeleting: deleteMutation.isPending,
    mutationError: upsertMutation.error ?? deleteMutation.error,
  };
};
